import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../../../_common';
import './AddRoleModal.scss';
import { PERMISSION_ROLE } from '../../../../graphql/client/mutations';
import { useMutation } from '@apollo/client/react';
import { ErrorLike } from '@apollo/client';
import { Textfield } from '../../../_common/Textfield/Textfield';
import { GET_ROLE_PERMISSIONS } from '../../../../graphql/client/queries';
import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';

const AddRoleModal = (): React.ReactElement => {
    const canEditPermissions = useAuthContext().userHasPermission(PermissionEnum.EditPermissions);
    const [showAddRole, setShowAddRole] = useState(false);
    const [roleName, setRoleName] = useState('');
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const [addRole] = useMutation(PERMISSION_ROLE, {
        onCompleted: () => {
            setShowAddRole(false);
            window.location.reload();
        },
        onError: (e: ErrorLike) => console.log('Error', e),
        refetchQueries: () => {
            return [
                {
                    query: GET_ROLE_PERMISSIONS,
                },
            ];
        },
    });

    const handleDismiss = (): void => {
        setShowAddRole(false);
    };

    const addNewRole = async (): Promise<void> => {
        const variables = {
            input: {
                name: roleName.replace(/ /g, ''),
                displayName: roleName,
            },
        };
        await addRole({ variables });
    };

    const checkIsCreateNewRoleEnabled = (): void => {
        if (canEditPermissions) {
            setShowAddRole(true);
        } else {
            setShowAddRole(false);
        }
    };

    return (
        <React.Fragment>
            <div className="AddRole-ButtonContainer">
                <div
                    className={`AddRole-HeaderRole ${canEditPermissions ? '' : 'AddRole-HeaderRole-Disabled'}`}
                    onClick={checkIsCreateNewRoleEnabled}
                >
                    <i className="material-icons Header-Icon">add_circle</i>
                    <span className="Header-Link">Create a New Role</span>
                </div>
            </div>

            <Modal className="AddRoleModal-Container" show={showAddRole} onHide={handleDismiss}>
                <Modal.Header className="AddRoleModal-Header">
                    <div className="AddRoleModal-Icon-Container">
                        <i className="material-icons AddRoleModal-X-Button" onClick={handleDismiss}>
                            close
                        </i>
                    </div>
                    <div className="AddRoleModal-Header-Container">
                        <div className="AddRoleModal-Header-Title">Create a New Role</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="AddRoleModal-Body">
                    <div className="AddRoleModal-BodyText">
                        <Textfield
                            label="Job Role"
                            onChange={event => {
                                const value = event.target.value;
                                if (value) {
                                    setRoleName(event.target.value);
                                    setIsSaveDisabled(false);
                                } else {
                                    setIsSaveDisabled(true);
                                }
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="AddRoleModal-Buttons-Container">
                        <CustomButton isBordered title="Cancel" onClick={handleDismiss}></CustomButton>
                        <div className="AddRoleModal-Button-Divider"></div>
                        <CustomButton
                            isDisabled={isSaveDisabled}
                            title="Save"
                            onClick={() => {
                                addNewRole();
                            }}
                        ></CustomButton>
                    </div>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

export default AddRoleModal;

